import { Card } from "@/src/components";
import { useRebase } from "@/src/context";
import { Timer } from "@/src/components/Timer";


export const HarvestInfo = () => {
  const { rebaseInterval, lastRebaseTime,} = useRebase();


  return (
    <Card>
      <div className="space-y-4">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">
          Next Harvest
        </h2>

        <div className="text-center py-3">
          <p className="text-2xl sm:text-3xl font-bold text-primary font-mono tracking-wide">
            {(parseInt(rebaseInterval)+parseInt(lastRebaseTime)) > 0 ? <Timer time={(parseInt(rebaseInterval)+parseInt(lastRebaseTime))}/> : "00:00:00"}
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            Time until next Harvest
          </p>
        </div>
      </div>
    </Card>
  );
};
